module.exports = __webpack_public_path__ + "static/media/500002.b08dd535.svg";